<template>
  <div class="transaction-results-component flex-column">
    <div class="transaction-results  transaction-results-title">
      {{ resultTitleText }}
    </div>

    <div class="transaction-results d-flex flex-column align-center justify-center fullwidth">
      <template v-if="isTerminalOk">
        <img src="/img/transactions-icons/terminal-complete.svg" alt="">
        <div class="transactions-price">
          {{ transaction.price / 100 | amountInRub }} ({{ transaction.quantityChecks }})
        </div>
      </template>
      <template v-else-if="isTerminalError">
        <img src="/img/transactions-icons/terminal-error.svg" alt="">
      </template>
      <template v-else-if="isCashOk">
        <img src="/img/transactions-icons/cash-complete.svg" alt="">
        <div class="transactions-price">
          {{ transaction.price / 100 | amountInRub }}
        </div>
      </template>
      <template v-else-if="isCashError">
        <img src="/img/transactions-icons/cash-error.svg" alt="">
      </template>
      <template v-else>
        <font-awesome-icon color="red" icon="times" />
      </template>
    </div>

    <v-btn @click="close" class="button-primary text-sm-h3 mt-5 mb-5 transaction-results-btn" height="80px" block>
      Вернуться к делам
    </v-btn>
  </div>
</template>

<script>
  import TransactionStatus from '@/models/enums/TransactionStatus'
  import TransactionPaymentType from '@/models/enums/TransactionPaymentType'

  export default {
    name: 'TransactionResults',
    props: {
      status: {
        type: String,
        default: null,
      },
      transaction: {
        type: Object,
        default: () => ({}),
      },
      results: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      resultTitleText () {
        if (this.transaction.status === TransactionStatus.Completed) {
          return 'Выполнено!'
        } else if (this.transaction.status === TransactionStatus.Cancel) {
          return 'Операция отменена'
        } else {
          return 'Ошибка. Статус транзакции ' + this.transaction.status
        }
      },

      isError () {
        return this.transaction.status !== TransactionStatus.Completed
      },

      isTerminalOk () {
        return this.transaction.paymentType === TransactionPaymentType.Terminal && !this.isError
      },
      isTerminalError () {
        return this.transaction.paymentType === TransactionPaymentType.Terminal && this.isError
      },
      isCashOk () {
        return this.transaction.paymentType === TransactionPaymentType.Cash && !this.isError
      },
      isCashError () {
        return this.transaction.paymentType === TransactionPaymentType.Cash && this.isError
      },
    },
    methods: {
      close () {
        this.$emit('close')
      },
    },
  }
</script>

<style lang="less" scoped>
  .transaction-results-component {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;

    svg {
      width: 200px;
      height: 200px;
    }

    .transaction-results {
      img {
        margin-left: 30px;
      }

      .transactions-price {
        margin-top: 40px;
        font-size: 30px;
        font-weight: 500;
      }

      &-title {
        font-size: 42px;
        font-weight: 500;
      }

      svg {
        width: 50px;
        height: 50px;
      }

      .transaction-from,
      .transaction-to {
        text-align: center;

        span {
          font-size: 24px;
          display: block;
          font-weight: 500;
        }
      }

      .transaction-from {
      }

      .transaction-to {
      }
    }
    .transaction-results-btn {
      flex-grow: 0;
    }
  }
</style>
